import { Button, Stack } from '@mui/material';
import { useState } from 'react';
import { record360Preview } from '../test/record_three_js';
import { app } from '../test/app_clean';

export function RecordPreviewButton() {
  const [recording, setRecording] = useState(false);
  const [urls, setUrls] = useState<{
    pngURL: string;
    webmURL: string;
  } | null>(null);

  const handleRecord = async () => {
    setRecording(true);

    const result = await record360Preview(app, {
      duration: 5,
      fps: 60,
      //   rotationOffsetX: - 25 * (Math.PI / 180),
      rotationOffsetX: -(Math.PI / 6),
      //   zoomOffset: 10.4,  office
      // zoomOffset: 5.4, office
      zoomOffset: 2.5,
      // positionOffsetY: -2,
      exportSize: { w: 1280, h: 720 },
    });

    setUrls(result);
    setRecording(false);
  };

  return (
    <Stack spacing={2}>
      <Button variant="contained" onClick={handleRecord} disabled={recording}>
        {recording ? 'Recording...' : 'Record 360 Preview'}
      </Button>

      {urls && (
        <>
          <a href={urls.pngURL} download="preview.png">
            Download PNG
          </a>
          <a href={urls.webmURL} download="preview.webm">
            Download WebM
          </a>
        </>
      )}
    </Stack>
  );
}
